import { useEffect, useState } from "react";

export default function FloatingTools() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`fixed bottom-6 right-5 z-50 flex flex-col gap-3 transition-all duration-300 md:right-8 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <button
        type="button"
        onClick={toTop}
        aria-label="返回顶部"
        className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-colors hover:bg-primary-600"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}